<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/news/newsheader.jpg" alt="" />
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 > 新闻动态 > 新闻</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <!-- 新闻首页 -->
      <div v-show="!detailShow">
        <div class="flex">
          <div class="left">
            <img src="../assets/news/newsImg.png" alt="" />
          </div>
          <div class="right">
            <div class="title">十四五工业绿色发展再接再厉</div>
            <div class="introduction">
              工信部近日对外公布《“十四五”工业绿色发展规划》，阐述“十四五”期间工业绿色发展的总体思路，明确了碳排放强度持续下降、
              污染物排放强度显著下降等发展目标和具体工作安排。特别提出，以数字化转型驱动生产方式变革。
            </div>
            <div class="morebtn" @click="routerDetail()">
              <img src="../assets/news/more.png" alt="" />
              <p>more ></p>
            </div>
          </div>
        </div>
        <div class="page">
          <el-pagination
            class="pagination"
            background
            layout="prev, pager, next"
            :total="0"
          >
          </el-pagination>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      
    };
  },
  mounted() {},
  computed: {},
  methods: {
    // 跳转到新闻详情页
    routerDetail() {
      this.$router.push('/newsdetail')
    },
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;

  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    img {
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .main {
    width: 100%;
    background: #f5f5fa;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405c80;
    padding: 40px 0;
    box-sizing: border-box;
    text-align: center;
    // 新闻首页
    .flex {
      width: 76%;
      margin: 0 12% 40px;
      display: flex;
      text-align: left;
      .left {
        img {
          height: 200px;
          width: auto;
        }
      }
      // 标题
      .title {
        font-size: 23px;
        color: #135de4;
        margin: 10px 20px;
        cursor: pointer;
      }
      // 内容介绍
      .introduction {
        font-size: 16px;
        color: #808080;
        margin: 10px 20px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
      // 了解更多
      .morebtn {
        position: relative;
        margin: 50px 20px 0;
        cursor: pointer;
        img {
          width: 112px;
          height: 36px;
        }
        p {
          position: absolute;
          top: 6px;
          left: 30px;
          color: #ffffff;
          font-size: 16px;
        }
      }
      // 分页
      .page {
        margin: 60px auto;
      }
    }
  }
}
</style>
